import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Clock, Filter } from "lucide-react";
import { useAuth } from "../lib/auth";

export default function Activity() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("");
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";

  const load = () => api.get("/activity", { params: { limit: 500 } })
                        .then(r => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => {
    load();
    const t = setInterval(load, 10000); // real-time-ish polling
    return () => clearInterval(t);
  }, []);

  const filtered = items.filter(a => {
    if (!filter) return true;
    const s = filter.toLowerCase();
    return (a.actor_name || "").toLowerCase().includes(s) ||
           (a.action || "").toLowerCase().includes(s) ||
           (a.entity || "").toLowerCase().includes(s);
  });

  return (
    <div className="space-y-6" data-testid="activity-page">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#8B6F47] font-semibold mb-2">Audit</div>
          <h1 className="font-display font-bold text-4xl tracking-tight text-[#2D2622]">
            {isAdmin ? "Every action, timestamped." : "Your activity log."}
          </h1>
          <p className="text-[#5D5148] mt-2 text-sm">
            {isAdmin ? "Complete history across all users. Auto-refreshes every 10 seconds." : "Live view of everything you've done."}
          </p>
        </div>
        <div className="relative">
          <Filter size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#8B6F47]"/>
          <input placeholder="Filter…" value={filter} onChange={(e) => setFilter(e.target.value)}
            className="h-10 pl-9 pr-3 border border-[#E5D8C4] bg-white text-sm focus:outline-none focus:border-[#2D2622]" />
        </div>
      </header>
      <div className="bg-white border border-[#E5D8C4] divide-y divide-[#F3ECDF]">
        {filtered.length === 0 && <div className="p-6 text-[#A8998A] text-sm">No activity yet.</div>}
        {filtered.map(a => (
          <div key={a.id} className="p-4 flex items-center gap-4">
            <div className="w-9 h-9 bg-[#F3ECDF] flex items-center justify-center">
              <Clock size={14} className="text-[#8B6F47]"/>
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm text-[#2D2622]">
                <span className="font-medium">{a.actor_name}</span>
                <span className="text-[#8B6F47]"> · </span>
                <span className="font-mono2 uppercase text-xs bg-[#F3ECDF] px-1.5 py-0.5">{a.action}</span>
                <span className="text-[#8B6F47]"> · </span>
                <span className="text-[#5D5148]">{a.entity}</span>
              </div>
              <div className="text-[10px] text-[#8B6F47] font-mono2 mt-1 truncate">
                {new Date(a.timestamp).toLocaleString()}
                {Object.keys(a.meta || {}).length > 0 && ` · ${JSON.stringify(a.meta)}`}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
